/**
 * Toast showing position change in leaderboard (rise/fall).
 */

import React from 'react';
import { useLeaderboardCelebration } from '../contexts/LeaderboardCelebrationContext';
import './PositionChangeToast.css';

function formatRankChange(prev, curr) {
  if (prev == null && curr == null) return null;
  if (prev == null) return `Now #${curr}`;
  if (curr == null) return `Dropped from #${prev}`;
  const diff = prev - curr;
  if (diff > 0) return `↑ #${prev} → #${curr}`;
  if (diff < 0) return `↓ #${prev} → #${curr}`;
  return `#${curr}`;
}

export default function PositionChangeToast() {
  const { positionChange, dismissPositionChange } = useLeaderboardCelebration();

  if (!positionChange) return null;

  const { tournamentId, tournamentName, prevSingles, prevDoubles, currSingles, currDoubles } = positionChange;
  const singlesChanged = prevSingles !== currSingles;
  const doublesChanged = prevDoubles !== currDoubles;
  if (!singlesChanged && !doublesChanged) return null;


  return (
    <div className="position-change-toast card-ui" role="status">
      <div className="position-change-toast__header">
        <span className="position-change-toast__icon" aria-hidden>📊</span>
        <span className="position-change-toast__title">Leaderboard updated</span>
      </div>
      <p className="position-change-toast__tournament">{tournamentName}</p>
      <div className="position-change-toast__changes">
        {singlesChanged && (
          <span className="position-change-toast__change">
            Singles: {formatRankChange(prevSingles, currSingles)}
          </span>
        )}
        {doublesChanged && (
          <span className="position-change-toast__change">
            Doubles: {formatRankChange(prevDoubles, currDoubles)}
          </span>
        )}
      </div>
      <div className="position-change-toast__actions">
        <a
          href={`/leaderboard?tournamentId=${encodeURIComponent(tournamentId)}`}
          onClick={(e) => { dismissPositionChange(); }}
          className="btn-primary btn-small"
        >
          View leaderboard
        </a>
        <button type="button" onClick={dismissPositionChange} className="btn-secondary btn-small">
          Dismiss
        </button>
      </div>
    </div>
  );
}
